export const getTradeMessages = () => {
    // メニュー
    const MENUS_MESSAGES = {
        TRADE: [
            { message: 'Trade', language: 'English' },
            { message: '取引', language: 'Japanese' },
            { message: '交易', language: 'Traditional' },
            { message: '交易', language: 'Simplified' },
        ],
        DEPOSIT: [
            { message: 'Deposit', language: 'English' },
            { message: '入金', language: 'Japanese' },
            { message: '存款', language: 'Traditional' },
            { message: '存款', language: 'Simplified' },
        ],
        WITHDRAW: [
            { message: 'Withdraw', language: 'English' },
            { message: '出金', language: 'Japanese' },
            { message: '提款', language: 'Traditional' },
            { message: '提款', language: 'Simplified' },
        ],
        TRADE_HISTORY: [
            { message: 'Trade History', language: 'English' },
            { message: '取引履歴', language: 'Japanese' },
            { message: '交易紀錄', language: 'Traditional' },
            { message: '交易纪录', language: 'Simplified' },
        ],
        LOGOUT: [
            { message: 'Log Out', language: 'English' },
            { message: 'ログアウト', language: 'Japanese' },
            { message: '登出', language: 'Traditional' },
            { message: '登出', language: 'Simplified' },
        ],
    };
    // ヘルプ機能
    const HELP = {
        MAIL: [
            { message: 'Contact us by e-mail', language: 'English' },
            { message: 'メールでのお問い合わせ', language: 'Japanese' },
            { message: '電郵查詢', language: 'Traditional' },
            { message: '电邮查询', language: 'Simplified' },
        ],
        CHAT: [
            { message: 'Chat with us', language: 'English' },
            { message: 'チャットで相談する', language: 'Japanese' },
            { message: '線上客服', language: 'Traditional' },
            { message: '线上客服', language: 'Simplified' },
        ],
        FAQ: [
            { message: 'FAQ', language: 'English' },
            { message: '質問集', language: 'Japanese' },
            { message: '常見問題', language: 'Traditional' },
            { message: '常见问题', language: 'Simplified' },
        ],
        VERSION: [
            { message: 'Version', language: 'English' },
            { message: 'バージョン', language: 'Japanese' },
            { message: '版本', language: 'Traditional' },
            { message: '版本', language: 'Simplified' },
        ],
    };
    // マーケット情報
    const MARKET_TITLES = {
        MARK_PRICE: [
            { message: 'Mark Price', language: 'English' },
            { message: 'マーク価格', language: 'Japanese' },
            { message: '市價', language: 'Traditional' },
            { message: '市价', language: 'Simplified' },
        ],
        CHANGE: [
            { message: '24h Change', language: 'English' },
            { message: '24時間価格変動', language: 'Japanese' },
            { message: '24小時價格變動', language: 'Traditional' },
            { message: '24小时价格变动', language: 'Simplified' },
        ],
        HIGH: [
            { message: '24h High', language: 'English' },
            { message: '24時間高値', language: 'Japanese' },
            { message: '24小時最高位', language: 'Traditional' },
            { message: '24小时最高位', language: 'Simplified' },
        ],
        LOW: [
            { message: '24h Low', language: 'English' },
            { message: '24時間安値', language: 'Japanese' },
            { message: '24小時最低位', language: 'Traditional' },
            { message: '24小時最低位', language: 'Simplified' },
        ],
    };
    // 通貨情報
    const CURRENCY_PAIR_HEADERS = {
        PAIR: [
            { message: 'Pair', language: 'English' },
            { message: '通貨ペア', language: 'Japanese' },
            { message: '貨幣對', language: 'Traditional' },
            { message: '货币对', language: 'Simplified' },
        ],
        PRICE: [
            { message: 'Price', language: 'English' },
            { message: '価格', language: 'Japanese' },
            { message: '價格', language: 'Traditional' },
            { message: '价格', language: 'Simplified' },
        ],
        CHANGE: [
            { message: 'Change', language: 'English' },
            { message: '変動', language: 'Japanese' },
            { message: '價格變動率', language: 'Traditional' },
            { message: '价格变动率', language: 'Simplified' },
        ],
    };
    // ORDER
    const ORDER_MESSAGES = {
        SUCCESS: [
            { message: 'Your order is successfull!', language: 'English' },
            { message: '注文が完了しました', language: 'Japanese' },
            { message: '您已成功下單！', language: 'Traditional' },
            { message: '您已成功下单！', language: 'Simplified' },
        ],
        ORDER_FAILED: [
            { message: 'We are sorry, your order has failed.', language: 'English' },
            { message: '注文に失敗しました', language: 'Japanese' },
            { message: '抱歉，下單失敗', language: 'Traditional' },
            { message: '抱歉，下单失败', language: 'Simplified' },
        ],
        WALLET_NOT_FOUND: [
            { message: 'We are currently unable to accept your order', language: 'English' },
            { message: '現在注文を受け付けておりません', language: 'Japanese' },
            { message: '抱歉，我們現在無法接受您的下單。', language: 'Traditional' },
            { message: '抱歉，我们现在无法接受您的下单。', language: 'Simplified' },
        ],
        NOT_FAIR_PRICE: [
            {
                message: 'Your order price deviates from the market price 30% , do you still want to proceed?',
                language: 'English',
            },
            { message: '注文価格が市場価格より30％乖離しています。注文を続行しますか？', language: 'Japanese' },
            { message: '您設定的價格現時偏離於市價的30%，是否繼續提交?', language: 'Traditional' },
            { message: '您设定的价格现时偏离于市价的30%，是否继续提交?', language: 'Simplified' },
        ],
        DONT_OWN_BALANCE: [
            { message: `Your balance is below the minimum requirement.`, language: 'English' },
            { message: '残高が取引に必要な最低金額を下回っています', language: 'Japanese' },
            { message: '您的餘額低於交易所需最低金額', language: 'Traditional' },
            { message: '您的余额低于交易所需最低金额', language: 'Simplified' },
        ],
        PRICE_OR_AMOUNT_0: [
            { message: 'Amount entered should be greater than 0.', language: 'English' },
            { message: '数量には0より大きい数字を入力してください', language: 'Japanese' },
            { message: '請確保數量需大於0', language: 'Traditional' },
            { message: '请确保数量需大于0', language: 'Simplified' },
        ],
        BALANCE_LESS_THAN_AMOUNT: [
            { message: 'Your amount is below the minimum requirement.', language: 'English' },
            { message: '数量が必要最低単位を下回っています', language: 'Japanese' },
            { message: '您設置的交易量低於最低要求', language: 'Traditional' },
            { message: '您设置的交易量低于最低要求', language: 'Simplified' },
        ],
        REQUIRE_ENOUGH_BALANCE: [
            { message: 'Your current asset is below the minimum requirement.', language: 'English' },
            { message: '口座残高が必要最低額を下回っています', language: 'Japanese' },
            { message: '您的流動資金過低，無法下單', language: 'Traditional' },
            { message: '您的流动资金过低，无法下单', language: 'Simplified' },
        ],
    };
    // Cancel
    const CANCEL_MESSAGES = {
        SUCCESS: [
            { message: 'Your cancellation is successfull!', language: 'English' },
            { message: 'キャンセルが完了しました', language: 'Japanese' },
            { message: '您的訂單已取消', language: 'Traditional' },
            { message: '您的订单已取消', language: 'Simplified' },
        ],
        CANCEL_FAILED: [
            { message: 'Cancellation made was unsuccessful.', language: 'English' },
            { message: 'キャンセルが出来ませんでした', language: 'Japanese' },
            { message: '您的訂單未能取消', language: 'Traditional' },
            { message: '您的订单未能取消', language: 'Simplified' },
        ],
    };
    // ORDER
    const ORDER = {
        OPEN_ACCOUNT: [
            { message: 'Open Account', language: 'English' },
            { message: '口座開設', language: 'Japanese' },
            { message: '申請賬戶', language: 'Traditional' },
            { message: '申请账户', language: 'Simplified' },
        ],
        LOGIN: [
            { message: 'Log In', language: 'English' },
            { message: 'ログイン', language: 'Japanese' },
            { message: '登入', language: 'Traditional' },
            { message: '登入', language: 'Simplified' },
        ],
        BUY: [
            { message: 'Buy', language: 'English' },
            { message: '買い注文', language: 'Japanese' },
            { message: '購入', language: 'Traditional' },
            { message: '购入', language: 'Simplified' },
        ],
        SELL: [
            { message: 'Sell', language: 'English' },
            { message: '売り注文', language: 'Japanese' },
            { message: '賣出', language: 'Traditional' },
            { message: '卖出', language: 'Simplified' },
        ],
        PRICE: [
            { message: 'Price', language: 'English' },
            { message: '価格', language: 'Japanese' },
            { message: '價格', language: 'Traditional' },
            { message: '价格', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Amount', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        LIMIT: [
            { message: 'Limit', language: 'English' },
            { message: '指値注文', language: 'Japanese' },
            { message: '限價', language: 'Traditional' },
            { message: '限价', language: 'Simplified' },
        ],
        MARKET: [
            { message: 'Market', language: 'English' },
            { message: '成行注文', language: 'Japanese' },
            { message: '市場', language: 'Traditional' },
            { message: '市场', language: 'Simplified' },
        ],
        CLEAR: [
            { message: 'clear', language: 'English' },
            { message: '消去', language: 'Japanese' },
            { message: '清除', language: 'Traditional' },
            { message: '清除', language: 'Simplified' },
        ],
        ONE_CLICK: [
            { message: '1 Click Order', language: 'English' },
            { message: 'ワンクリックオーダー', language: 'Japanese' },
            { message: '快速下單', language: 'Traditional' },
            { message: '快速下单', language: 'Simplified' },
        ],
    };
    const CHART_MESSAGES = {
        TITLE: [
            { message: 'CHART', language: 'English' },
            { message: 'チャート', language: 'Japanese' },
            { message: '圖表', language: 'Traditional' },
            { message: '图表', language: 'Simplified' },
        ],
    };
    // 歩み値
    const HISTORY_FIELDS = {
        TITLE: [
            { message: 'HISTORY', language: 'English' },
            { message: '履歴', language: 'Japanese' },
            { message: '歷史紀錄', language: 'Traditional' },
            { message: '历史纪录', language: 'Simplified' },
        ],
    };
    // 板情報
    const ORDERBOOK_FIELDS = {
        TITLE: [
            { message: 'ORDERBOOK', language: 'English' },
            { message: '板', language: 'Japanese' },
            { message: '訂單簿', language: 'Traditional' },
            { message: '订单簿', language: 'Simplified' },
        ],
        PRICE: [
            { message: 'Price', language: 'English' },
            { message: '価格', language: 'Japanese' },
            { message: '價格', language: 'Traditional' },
            { message: '价格', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Amount', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        TOTAL_AMOUNT: [
            { message: 'Total', language: 'English' },
            { message: '合計金額', language: 'Japanese' },
            { message: '合計金額', language: 'Traditional' },
            { message: '合计金额', language: 'Simplified' },
        ],
        SPREAD: [
            { message: 'Spread', language: 'English' },
            { message: 'スプレッド', language: 'Japanese' },
            { message: '點差', language: 'Traditional' },
            { message: '点差', language: 'Simplified' },
        ],
    };
    // バランス
    const BALANCES_TITLES = {
        TITLE: [
            { message: 'BALANCES', language: 'English' },
            { message: '残高', language: 'Japanese' },
            { message: '餘額', language: 'Traditional' },
            { message: '余额', language: 'Simplified' },
        ],
        LIST: [
            { message: 'List', language: 'English' },
            { message: '一覧', language: 'Japanese' },
            { message: '一覽', language: 'Traditional' },
            { message: '一览', language: 'Simplified' },
        ],
        GRAPH: [
            { message: 'Allocation', language: 'English' },
            { message: '資産配分', language: 'Japanese' },
            { message: '資產構成', language: 'Traditional' },
            { message: '资产构成', language: 'Simplified' },
        ],
        ALLOCATION: [
            { message: 'Allocation', language: 'English' },
            { message: '資産配分', language: 'Japanese' },
            { message: '资产构成', language: 'Traditional' },
            { message: '資產構成', language: 'Simplified' },
        ],
        ALLOCATION_TOTAL: [
            { message: 'Total', language: 'English' },
            { message: '合計', language: 'Japanese' },
            { message: '合計', language: 'Traditional' },
            { message: '合计', language: 'Simplified' },
        ],
        ALLOCATION_OTHERS: [
            { message: 'Others', language: 'English' },
            { message: 'その他', language: 'Japanese' },
            { message: '其他', language: 'Traditional' },
            { message: '其他', language: 'Simplified' },
        ],
    };
    const BALANCES_HEADERS = {
        CURRENCY: [
            { message: 'Currency', language: 'English' },
            { message: '通貨', language: 'Japanese' },
            { message: '貨幣', language: 'Traditional' },
            { message: '货币', language: 'Simplified' },
        ],
        BALANCE: [
            { message: 'Balance', language: 'English' },
            { message: '残高', language: 'Japanese' },
            { message: '餘額', language: 'Traditional' },
            { message: '余额', language: 'Simplified' },
        ],
        ON_HOLD: [
            { message: 'onHold', language: 'English' },
            { message: '保有中', language: 'Japanese' },
            { message: '持有貨幣', language: 'Traditional' },
            { message: '持有货币', language: 'Simplified' },
        ],
    };
    const BALANCES_FIELDS = {
        SHOW_ALL: [
            { message: 'Show All', language: 'English' },
            { message: 'すべて表示', language: 'Japanese' },
            { message: '顯示全部', language: 'Traditional' },
            { message: '显示全部', language: 'Simplified' },
        ],
    };
    // 注文情報
    const ORDERS_TITLES = {
        OPEN_ORDERS: [
            { message: 'OPEN ORDERS', language: 'English' },
            { message: '未約定注文', language: 'Japanese' },
            { message: '未完成訂單', language: 'Traditional' },
            { message: '未完成订单', language: 'Simplified' },
        ],
        CLOSED_ORDERS: [
            { message: 'CLOSED ORDERS', language: 'English' },
            { message: '約定済注文', language: 'Japanese' },
            { message: '已完成的訂單', language: 'Traditional' },
            { message: '已完成的订单', language: 'Simplified' },
        ],
    };
    const OPEN_ORDERS_HEADERS = {
        TIME: [
            { message: 'Time', language: 'English' },
            { message: '時間', language: 'Japanese' },
            { message: '時間', language: 'Traditional' },
            { message: '时间', language: 'Simplified' },
        ],
        SIDE: [
            { message: 'Side', language: 'English' },
            { message: '売買', language: 'Japanese' },
            { message: '買入/賣出', language: 'Traditional' },
            { message: '买入/卖出', language: 'Simplified' },
        ],
        PAIR: [
            { message: 'Pair', language: 'English' },
            { message: '通貨ペア', language: 'Japanese' },
            { message: '貨幣對', language: 'Traditional' },
            { message: '货币对', language: 'Simplified' },
        ],
        PRICE: [
            { message: 'Price', language: 'English' },
            { message: '価格', language: 'Japanese' },
            { message: '價格', language: 'Traditional' },
            { message: '价格', language: 'Simplified' },
        ],
        EXCUTED_AND_AMOUNT: [
            { message: 'Executed / Amount', language: 'English' },
            { message: '約定済み/注文数量', language: 'Japanese' },
            { message: '成交量/ 下單量', language: 'Traditional' },
            { message: '成交量/ 下单量', language: 'Simplified' },
        ],
        ACTION: [
            { message: 'Action', language: 'English' },
            { message: '操作', language: 'Japanese' },
            { message: '動作', language: 'Traditional' },
            { message: '动作', language: 'Simplified' },
        ],
    };
    const OPEN_ORDERS_FIELDS = {
        CANCEL: [
            { message: 'Cancel', language: 'English' },
            { message: '取消', language: 'Japanese' },
            { message: '取消', language: 'Traditional' },
            { message: '取消', language: 'Simplified' },
        ],
    };
    const CLOSED_ORDERS_HEADERS = {
        TIME: [
            { message: 'Time', language: 'English' },
            { message: '時間', language: 'Japanese' },
            { message: '時間', language: 'Traditional' },
            { message: '时间', language: 'Simplified' },
        ],
        SIDE: [
            { message: 'Side', language: 'English' },
            { message: '売買', language: 'Japanese' },
            { message: '買入/賣出', language: 'Traditional' },
            { message: '买入/卖出', language: 'Simplified' },
        ],
        PAIR: [
            { message: 'Pair', language: 'English' },
            { message: '通貨ペア', language: 'Japanese' },
            { message: '貨幣對', language: 'Traditional' },
            { message: '货币对', language: 'Simplified' },
        ],
        PRICE: [
            { message: 'Price', language: 'English' },
            { message: '価格', language: 'Japanese' },
            { message: '價格', language: 'Traditional' },
            { message: '价格', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Amount', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        FEE: [
            { message: 'Fee', language: 'English' },
            { message: '手数料', language: 'Japanese' },
            { message: '手續費', language: 'Traditional' },
            { message: '手续费', language: 'Simplified' },
        ],
    };
    const CLOSED_ORDERS_MESSAGES = {
        SUCCESS: [
            { message: 'Your order has contracted!', language: 'English' },
            { message: '注文が約定しました！', language: 'Japanese' },
            { message: '您的訂單已交易成功！', language: 'Traditional' },
            { message: '您的订单已交易成功！', language: 'Simplified' },
        ],
    };
    const MY_ORDER_PAIRS_CHECK = {
        FIELD: [
            { message: 'Hide Other Pairs', language: 'English' },
            { message: '他のペアを非表示', language: 'Japanese' },
            { message: '隱藏其他交易對', language: 'Traditional' },
            { message: '隐藏其他交易对', language: 'Simplified' },
        ],
    };
    const SMART_PHONE_ORDER_FIELDS = {
        TITLE: [
            { message: 'Order', language: 'English' },
            { message: '注文', language: 'Japanese' },
            { message: '訂單', language: 'Traditional' },
            { message: '訂單', language: 'Simplified' },
        ],
    };
    // 注文Confirm
    const ORDER_CONFIRM_TITLES = {
        TITLE: [
            { message: 'Confirm', language: 'English' },
            { message: '確認画面', language: 'Japanese' },
            { message: '請確認下單內容', language: 'Traditional' },
            { message: '请确认下单内容', language: 'Simplified' },
        ],
        ORDER: [
            { message: 'Order', language: 'English' },
            { message: '注文', language: 'Japanese' },
            { message: '訂單類別', language: 'Traditional' },
            { message: '订单类别', language: 'Simplified' },
        ],
        PAIR: [
            { message: 'Pair', language: 'English' },
            { message: '通貨ペア', language: 'Japanese' },
            { message: '貨幣對', language: 'Traditional' },
            { message: '货币对', language: 'Simplified' },
        ],
        LIMIT_OR_MARKET: [
            { message: 'Limit / Market', language: 'English' },
            { message: '指値注文/成行注文', language: 'Japanese' },
            { message: '限價訂單/市場訂單', language: 'Traditional' },
            { message: '限价订单/市场订单', language: 'Simplified' },
        ],
        PRICE: [
            { message: 'Order Price', language: 'English' },
            { message: '注文価格', language: 'Japanese' },
            { message: '訂單價格', language: 'Traditional' },
            { message: '订单价格', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Order Amount', language: 'English' },
            { message: '注文数量', language: 'Japanese' },
            { message: '訂單數量', language: 'Traditional' },
            { message: '訂單数量', language: 'Simplified' },
        ],
        EXPECTED_TOTAL: [
            { message: 'Expected Total Price', language: 'English' },
            { message: '予定合計金額', language: 'Japanese' },
            { message: '預期的總價格', language: 'Traditional' },
            { message: '预期的总价格', language: 'Simplified' },
        ],
        AVAILABLE_BALANCE: [
            { message: 'Available Balance', language: 'English' },
            { message: '利用可能残高', language: 'Japanese' },
            { message: '可用餘額', language: 'Traditional' },
            { message: '可用余额', language: 'Simplified' },
        ],
        MARKET_PRICE: [
            { message: 'Mark Price', language: 'English' },
            { message: '表示価格', language: 'Japanese' },
            { message: '標示價格', language: 'Traditional' },
            { message: '标示价格', language: 'Simplified' },
        ],
        CLOSE: [
            { message: 'Close', language: 'English' },
            { message: '閉じる', language: 'Japanese' },
            { message: '關閉', language: 'Traditional' },
            { message: '关闭', language: 'Simplified' },
        ],
        LEAVE_OUT_CHECK: [
            { message: 'Leave out from the next time', language: 'English' },
            { message: '次回からこのダイアログは表示しない', language: 'Japanese' },
            { message: '下次不再提醒我  ', language: 'Traditional' },
            { message: '下次不再提醒我', language: 'Simplified' },
        ],
    };
    // キャンセルConfirm
    const CANCEL_CONFIRM_TITLES = {
        TITLE: [
            { message: 'Confirm', language: 'English' },
            { message: '確認画面', language: 'Japanese' },
            { message: '請確認欲取消內容', language: 'Traditional' },
            { message: '请确认欲取消内容', language: 'Simplified' },
        ],
        ORDER_ID: [
            { message: 'Order ID', language: 'English' },
            { message: '注文番号', language: 'Japanese' },
            { message: '訂單編號', language: 'Traditional' },
            { message: '订单编号', language: 'Simplified' },
        ],
        PAIR: [
            { message: 'Pair', language: 'English' },
            { message: '通貨ペア', language: 'Japanese' },
            { message: '貨幣對', language: 'Traditional' },
            { message: '货币对', language: 'Simplified' },
        ],
        ORDER: [
            { message: 'Order', language: 'English' },
            { message: '注文', language: 'Japanese' },
            { message: '訂單類別', language: 'Traditional' },
            { message: '订单类别', language: 'Simplified' },
        ],
        EXCUTED_STATUS: [
            { message: 'Executed Status', language: 'English' },
            { message: '実行状態', language: 'Japanese' },
            { message: '執行狀態', language: 'Traditional' },
            { message: '执行状态', language: 'Simplified' },
        ],
        EXCUTED_AND_AMOUNT: [
            { message: 'Executed / Amount', language: 'English' },
            { message: '約定済み/注文数量', language: 'Japanese' },
            { message: '成交量/ 下單量', language: 'Traditional' },
            { message: '成交量/ 下单量', language: 'Simplified' },
        ],
        ORDER_TIME: [
            { message: 'Order Time', language: 'English' },
            { message: '注文時間', language: 'Japanese' },
            { message: '下單時間', language: 'Traditional' },
            { message: '下单时间', language: 'Simplified' },
        ],
        CLOSE: [
            { message: 'Close', language: 'English' },
            { message: '閉じる', language: 'Japanese' },
            { message: '關閉', language: 'Traditional' },
            { message: '关闭', language: 'Simplified' },
        ],
        CANCEL: [
            { message: 'Cancel', language: 'English' },
            { message: '取消', language: 'Japanese' },
            { message: '確認取消', language: 'Traditional' },
            { message: '确认取消', language: 'Simplified' },
        ],
        LEAVE_OUT_CHECK: [
            { message: 'Leave out from the next time', language: 'English' },
            { message: '次回からこのダイアログは表示しない', language: 'Japanese' },
            { message: '下次不再提醒我', language: 'Traditional' },
            { message: '下次不再提醒我', language: 'Simplified' },
        ],
    };
    // 自身の取引履歴情報
    const TRADE_HISTORY_TITLES = {
        TRADE_HISTORY: [
            { message: 'Trade History', language: 'English' },
            { message: '取引履歴', language: 'Japanese' },
            { message: '交易紀錄', language: 'Traditional' },
            { message: '交易纪录', language: 'Simplified' },
        ],
        SELECT_THE_TERM: [
            { message: 'Select the Term', language: 'English' },
            { message: '期間を選択してください', language: 'Japanese' },
            { message: '選擇時段', language: 'Traditional' },
            { message: '选择时段', language: 'Simplified' },
        ],
    };
    const TRADE_HISTORY_FIELDS = {
        FROM: [
            { message: 'From', language: 'English' },
            { message: '開始日', language: 'Japanese' },
            { message: '由', language: 'Traditional' },
            { message: '由', language: 'Simplified' },
        ],
        TO: [
            { message: 'To', language: 'English' },
            { message: '終了日', language: 'Japanese' },
            { message: '至', language: 'Traditional' },
            { message: '至', language: 'Simplified' },
        ],
        GENERATE_CSV: [
            { message: 'Generate CSV File', language: 'English' },
            { message: 'CSVファイルを生成', language: 'Japanese' },
            { message: '生成CSV檔案', language: 'Traditional' },
            { message: '生成CSV档案', language: 'Simplified' },
        ],
    };
    const TRADE_HISTORY_HEADER_TITLES = {
        TXID: [
            { message: 'TxID', language: 'English' },
            { message: 'TxID', language: 'Japanese' },
            { message: '交易编號', language: 'Traditional' },
            { message: '交易编号', language: 'Simplified' },
        ],
        CREATED: [
            { message: 'Created at', language: 'English' },
            { message: '取引日時', language: 'Japanese' },
            { message: '建立於', language: 'Traditional' },
            { message: '建立于', language: 'Simplified' },
        ],
        TYPE: [
            { message: 'Type', language: 'English' },
            { message: '種類', language: 'Japanese' },
            { message: '種類', language: 'Traditional' },
            { message: '种类', language: 'Simplified' },
        ],
        CURRENCY: [
            { message: 'Currency', language: 'English' },
            { message: '通貨', language: 'Japanese' },
            { message: '貨幣', language: 'Traditional' },
            { message: '货币', language: 'Simplified' },
        ],
        AMOUNT: [
            { message: 'Amount', language: 'English' },
            { message: '数量', language: 'Japanese' },
            { message: '數量', language: 'Traditional' },
            { message: '数量', language: 'Simplified' },
        ],
        COMMISSION: [
            { message: 'Commission', language: 'English' },
            { message: '手数料', language: 'Japanese' },
            { message: '手續費', language: 'Traditional' },
            { message: '手续费', language: 'Simplified' },
        ],
        BALANCE: [
            { message: 'Balance', language: 'English' },
            { message: '残高', language: 'Japanese' },
            { message: '餘額', language: 'Traditional' },
            { message: '余额', language: 'Simplified' },
        ],
    };
    const TRADE_HISTORY_MESSAGES = {
        CONFIRM: [
            { message: 'Trade history will be sent to your email address, do you want to proceed?', language: 'English' },
            { message: '取引履歴はメールアドレスへ送信されます。実行しますか？', language: 'Japanese' },
            { message: '是否要將交易紀錄會發送到您的電子郵箱？', language: 'Traditional' },
            { message: '是否要将交易纪录会发送到您的电子邮箱？', language: 'Simplified' },
        ],
        SUCCESS: [
            {
                message: 'CSV file for Trading History that you requested was sent successfully to your e-mail address',
                language: 'English',
            },
            { message: '取引履歴(CSVファイル)は、お客様のメールアドレス宛に送信されました。', language: 'Japanese' },
            { message: 'CSV檔案已成功發送至您的電子郵箱', language: 'Traditional' },
            { message: 'CSV档案已成功发送至您的电子邮箱', language: 'Simplified' },
        ],
    };
    const TRADE_HISTORY_TYPE_DISPLAY = [
        {
            type: 'order_execution_maker',
            message: 'order_execution',
            language: 'English',
        },
        {
            type: 'order_execution_maker',
            message: 'メイカー',
            language: 'Japanese',
        },
        {
            type: 'order_execution_maker',
            message: '訂單執行者',
            language: 'Traditional',
        },
        {
            type: 'order_execution_maker',
            message: '订单执行者',
            language: 'Simplified',
        },
        {
            type: 'order_execution_taker',
            message: 'order_execution',
            language: 'English',
        },
        {
            type: 'order_execution_taker',
            message: 'テイカー',
            language: 'Japanese',
        },
        {
            type: 'order_execution_taker',
            message: '訂單接收者',
            language: 'Traditional',
        },
        {
            type: 'order_execution_taker',
            message: '订单接收者',
            language: 'Simplified',
        },
        {
            type: 'deposit',
            message: 'deposit',
            language: 'English',
        },
        {
            type: 'deposit',
            message: '入金',
            language: 'Japanese',
        },
        {
            type: 'deposit',
            message: '存款',
            language: 'Traditional',
        },
        {
            type: 'deposit',
            message: '存款',
            language: 'Simplified',
        },
        {
            type: 'withdrawal',
            message: 'withdrawal',
            language: 'English',
        },
        {
            type: 'withdrawal',
            message: '出金',
            language: 'Japanese',
        },
        {
            type: 'withdrawal',
            message: '提款',
            language: 'Traditional',
        },
        {
            type: 'withdrawal',
            message: '提款',
            language: 'Simplified',
        },
        {
            type: 'rebate',
            message: 'rebate',
            language: 'English',
        },
        {
            type: 'rebate',
            message: '報酬',
            language: 'Japanese',
        },
        {
            type: 'rebate',
            message: '回扣',
            language: 'Traditional',
        },
        {
            type: 'rebate',
            message: '回扣',
            language: 'Simplified',
        },
        {
            type: 'exchange',
            message: 'exchange',
            language: 'English',
        },
        {
            type: 'exchange',
            message: '両替',
            language: 'Japanese',
        },
        {
            type: 'exchange',
            message: '兌換',
            language: 'Traditional',
        },
        {
            type: 'exchange',
            message: '兑换',
            language: 'Simplified',
        },
        {
            type: 'transfer_in',
            message: 'transfer_in',
            language: 'English',
        },
        {
            type: 'transfer_in',
            message: '振替（入金）',
            language: 'Japanese',
        },
        {
            type: 'transfer_in',
            message: '轉帳(入金)',
            language: 'Traditional',
        },
        {
            type: 'transfer_in',
            message: '转账（入金）',
            language: 'Simplified',
        },
        {
            type: 'transfer_out',
            message: 'transfer_out',
            language: 'English',
        },
        {
            type: 'transfer_out',
            message: '振替（出金）',
            language: 'Japanese',
        },
        {
            type: 'transfer_out',
            message: '轉帳(出金)',
            language: 'Traditional',
        },
        {
            type: 'transfer_out',
            message: '转账（出金）',
            language: 'Simplified',
        },
    ];
    // 設定
    const THEME_SWITCH_MESSAGES = {
        TITLE: [
            { message: 'Theme Color', language: 'English' },
            { message: 'テーマカラー', language: 'Japanese' },
            { message: '主題顏色', language: 'Traditional' },
            { message: '主题颜色', language: 'Simplified' },
        ],
        DARK: [
            { message: 'Dark', language: 'English' },
            { message: 'ダーク', language: 'Japanese' },
            { message: '暗黑', language: 'Traditional' },
            { message: '暗黑', language: 'Simplified' },
        ],
        LIGHT: [
            { message: 'Light', language: 'English' },
            { message: 'ライト', language: 'Japanese' },
            { message: '明亮', language: 'Traditional' },
            { message: '明亮', language: 'Simplified' },
        ],
    };
    const USER_SETTINGS_MESSAGES = {
        ORDER_CONFIRM: [
            { message: 'Leave Out Order Confirm', language: 'English' },
            { message: '注文時の確認ダイアログを非表示', language: 'Japanese' },
            { message: '下單時不需再確認', language: 'Traditional' },
            { message: '下单时不需再确认', language: 'Simplified' },
        ],
        CANCEL_CONFIRM: [
            { message: 'Leave Out Cancel Confirm', language: 'English' },
            { message: 'キャンセル時の確認ダイアログを非表示', language: 'Japanese' },
            { message: '取消訂單時不需再確認', language: 'Traditional' },
            { message: '取消订单时不需再确认', language: 'Simplified' },
        ],
        SOUND: [
            { message: 'Sound', language: 'English' },
            { message: '効果音', language: 'Japanese' },
            { message: '聲效', language: 'Traditional' },
            { message: '声效', language: 'Simplified' },
        ],
        LANGUAGE: [
            { message: 'Language', language: 'English' },
            { message: '言語', language: 'Japanese' },
            { message: '语言', language: 'Traditional' },
            { message: '语言', language: 'Simplified' },
        ],
        TIME_ZONE: [
            { message: 'Time Zone', language: 'English' },
            { message: '標準時間', language: 'Japanese' },
            { message: '時區', language: 'Traditional' },
            { message: '时区', language: 'Simplified' },
        ],
        LANGUAGE_SHORT: [
            { message: 'US', language: 'English' },
            { message: 'JP', language: 'Japanese' },
            { message: 'TW', language: 'Traditional' },
            { message: 'CN', language: 'Simplified' },
        ],
    };
    // エラー文言
    const ERRORS = {
        MAINTENANCE: [
            { message: 'Sorry, we are currently under maintenance.', language: 'English' },
            { message: '申し訳ございません。只今メンテナンス中でございます。', language: 'Japanese' },
            { message: '抱歉，服務現正進行維護中。', language: 'Traditional' },
            { message: '抱歉，服务现正进行维护中。', language: 'Simplified' },
        ],
        UNAUTHORIZED: [
            { message: 'Authentication failed.', language: 'English' },
            { message: '認証に失敗しました。', language: 'Japanese' },
            { message: '驗證失敗。', language: 'Traditional' },
            { message: '验证失败。', language: 'Simplified' },
        ],
        FORBIDDEN: [
            { message: 'Cannot login to CRYPTOS.', language: 'English' },
            {
                message: 'CRYPTOSにログインすることができません。',
                language: 'Japanese',
            },
            { message: '無法登入CRYPTOS。', language: 'Traditional' },
            { message: '无法登入CRYPTOS。', language: 'Simplified' },
        ],
        SYSTEM_ERROR: [
            {
                message: 'An unexpected error has occurred.',
                language: 'English',
            },
            {
                message: '予期しないエラーが発生しました。',
                language: 'Japanese',
            },
            { message: '發生意外錯誤。', language: 'Traditional' },
            { message: '发生意外错误。', language: 'Simplified' },
        ],
    };
    // 異常、データなしなど
    const EXCEPTIONS = {
        NO_DATA: [
            { message: 'No data.', language: 'English' },
            { message: 'データなし', language: 'Japanese' },
            { message: '沒有數據', language: 'Traditional' },
            { message: '没有数据', language: 'Simplified' },
        ],
        REFRESH: [
            { message: 'Data lost due to connection error, please refresh the page.', language: 'English' },
            { message: '接続エラーによりデータを失いました。ページを更新してください。', language: 'Japanese' },
            { message: '連接錯誤導致數據丟失，請刷新頁面', language: 'Traditional' },
            { message: '连接错误导致数据丢失，请刷新页面', language: 'Simplified' },
        ],
        REFRESH_BUTTON: [
            { message: 'Refresh', language: 'English' },
            { message: '更新', language: 'Japanese' },
            { message: '更新', language: 'Traditional' },
            { message: '更新', language: 'Simplified' },
        ],
        NETWORK_ERROR: [
            { message: 'Network disconnected, please refresh the page.', language: 'English' },
            { message: 'ネットワークが切断されました。ページを更新してください。', language: 'Japanese' },
            { message: '網絡中斷，請刷新頁面', language: 'Traditional' },
            { message: '网络中断，请刷新页面', language: 'Simplified' },
        ],
    };
    return {
        MENUS_MESSAGES,
        HELP,
        MARKET_TITLES,
        CURRENCY_PAIR_HEADERS,
        ORDER,
        ORDER_MESSAGES,
        HISTORY_FIELDS,
        ORDERBOOK_FIELDS,
        CHART_MESSAGES,
        BALANCES_TITLES,
        BALANCES_HEADERS,
        BALANCES_FIELDS,
        ORDERS_TITLES,
        OPEN_ORDERS_HEADERS,
        OPEN_ORDERS_FIELDS,
        CLOSED_ORDERS_HEADERS,
        CLOSED_ORDERS_MESSAGES,
        MY_ORDER_PAIRS_CHECK,
        SMART_PHONE_ORDER_FIELDS,
        ORDER_CONFIRM_TITLES,
        CANCEL_MESSAGES,
        CANCEL_CONFIRM_TITLES,
        TRADE_HISTORY_TITLES,
        TRADE_HISTORY_FIELDS,
        TRADE_HISTORY_HEADER_TITLES,
        TRADE_HISTORY_MESSAGES,
        TRADE_HISTORY_TYPE_DISPLAY,
        THEME_SWITCH_MESSAGES,
        USER_SETTINGS_MESSAGES,
        ERRORS,
        EXCEPTIONS,
    };
};
